<template>
  <el-row style="padding: 1.25rem;">
    <div v-if="liad_show">
      <load></load>
    </div>
    <el-row style="margin-top: 0.625rem;">
      <el-input @change="input_change()" v-model="input" style="width: 12.5rem;float: right;"  placeholder="请输入内容"></el-input>
    </el-row>
    <el-row  v-if="pagination.total!=0">
      <el-card class="box-card" style="margin-top: 1.25rem;" v-for="(item,index) in list" :key="index">
        <el-row slot="header" class="clearfix">
          <el-col :span="11" >
            <span style="font-size: 16px;line-height: 22px;">{{item.name}}</span>
          </el-col>
          <el-col :span="11" :offset="1">
            <span style="font-size: 16px;line-height: 22px;float: right;color: #409EFF;" @click="name_goto(item.i_num)">关联问卷：{{item.i_name}}</span>
          </el-col>
          <!-- <span style="font-size: 16px;line-height: 22px;">问卷名称：{{item.i_name}}</span> -->
          <!-- <el-button style="float: right; padding: 3px 0" type="text">操作按钮</el-button> -->
        </el-row>
        <el-row  class="text item">
          <span>
            <span style="margin-right: 1.25rem;">创建人：{{item.a_id}}</span>
            <span  style="margin-right: 1.25rem;">
              <span  v-if="item.status==1">状 态：<span style="color: #0095ff;">启用中</span>
              </span>
              <span v-else-if="item.status==0" >状 态：
              <span style="color: orange;">已禁用</span>
              </span>
              <span v-else>状 态：
              <span style="color: red;">已删除</span>
              </span>
            </span>
            <span>
              人数：{{item.companyee}}
            </span>
            <span style="margin-left: 0.625rem;">
              发布时间：{{item.c_time}}
            </span>
<!--            <span  style="margin-right: 1.25rem;">开始时间：{{item.c_time}}</span>
            <span  style="margin-right: 1.25rem;">结束时间：{{item.c_time}}</span> -->
          </span>
          <span style="float: right;"  v-if="item.status==1">
<!--            <span class="con_right" @click="goto('release',item.num)">发布</span>
            <span class="con_right" @click="goto('preview',item.num)">预览</span> -->
            <span class="con_right" @click="goto('details',item.num)" >详情</span>
            <span class="con_right" @click="goto('data',item.num)" >统计</span>
            <span class="con_right" @click="goto('retrieval',item.num)" style="color: #409EFF;">检索</span>
            <span class="con_right"   style="color: orange;">
              <el-popconfirm title='确认禁用？？？'
                   confirm-button-text='确定'
                   cancel-button-text='取消'
                   icon='el-icon-delete'
                   icon-color='red'
                   @confirm='handleConfirm_dis(item.num)'
                   @cancel='handleCancel'>
                   <span slot='reference'>禁用</span>
               </el-popconfirm>
              </span>
            <span class="con_right" style="color: red;">
              <el-popconfirm title='确认删除？？？'
                   confirm-button-text='确定'
                   cancel-button-text='取消'
                   icon='el-icon-delete'
                   icon-color='red'
                   @confirm='handleConfirm_del(item.num)'
                   @cancel='handleCancel'>
                   <span slot='reference'>删除</span>
               </el-popconfirm></span>
          </span>
        </el-row>
      </el-card>
      <el-row style="text-align: center;margin-top: 1.875rem;">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[4, 8,16,42]"
          :page-size="100"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-row>
    </el-row>

    <el-row v-else style="height: 300px; display: flex;justify-content: center;align-items: center;background: white;margin-top: 20px;">
      <p>未检测到您的记录哦，快去发起调查吧！！！！</p>
    </el-row>

    <el-dialog
      title="检索"
      :visible.sync="retrieval.show"
       width="50%"
      >
      <span>总人数：{{retrieval.list.list.length}}</span>
      <span style="margin-left: 1.25rem;">
        (<span style="color: red;">失败人数：{{retrieval.list.f}}</span>
        <span style="margin-left: 1.25rem;">成功人数：{{retrieval.list.t}}</span>)
      </span>
       <el-table
           :height="dialog_height"
          :data="retrieval.list.list"
           tooltip-effect="dark"
          style="width: 100%;overflow: auto;"
           max-height="400"
            :key="retrieval.bomkey_all"
          @selection-change="again_Change">
          <el-table-column
            type="selection"
            :selectable="selectable"
            width="55">
          </el-table-column>
          <el-table-column
            label="员工名称"
            prop="rale_name">
          </el-table-column>
          <el-table-column
            label="状态"
            prop="name">
            <template slot-scope="scope">
              <span v-if="scope.row.status" >成功</span>
              <span v-else style="color: red">失败</span>
            </template>
          </el-table-column>
        </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="again()" >重新发送</el-button>
        <el-button @click="retrieval.show= false">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="任务详情"
      :visible.sync="details.show"
       width="50%"
      >
      <p>任务名称：{{details.list_info.name}}</p>
     <p>问卷名称：{{details.list_info.i_name}}</p>
      <p>发布人：{{details.list_info.companyee}}</p>
      <p>
      <span style="margin-right: 0.625rem;">开始时间：{{details.list_info.start}}</span>
      <span style="margin-right: 0.625rem;">结束时间：{{details.list_info.end}}</span>
      </p>
      <el-row>
        培训人员任务状态:
        <span style="color: red;">未完成：{{details.list_com0.length}}</span>
        <span style="color: limegreen;">已完成：{{details.list_com1.length}}</span>
        <span >已移除：{{details.list_com2.length}}</span>
        <el-tabs type="border-card" style="margin-top: 1.25rem;">
          <el-tab-pane label="未完成">
            <el-table
            :data="details.list_com0"
            border
             height="250"
            style="width: 100%">
            <el-table-column
              label="序号"
              align="center"
              type="index"
              :index="indexAdd"
              width="50"/>
             </el-table-column>
            <el-table-column
              prop="companyee"
              label="姓名"
              width="150">
            </el-table-column>
            <el-table-column
              label="操作"
             >
              <template slot-scope="scope">
                <el-popconfirm title='确认移除？？？'
                     confirm-button-text='确定'
                     cancel-button-text='取消'
                     icon='el-icon-delete'
                     icon-color='red'
                     @confirm='handleConfirm_move(scope.row.num)'
                     @cancel='handleCancel'>
                     <span slot='reference'>移除</span>
                 </el-popconfirm>
                <!-- <el-button
                @click="train_companyee_remove(nav_status.train_info_dialog.data,scope.row,num.incomplete_list,'incomplete_list')"
                type="text" size="small">移除</el-button> -->
              </template>
            </el-table-column>
          </el-table>
          </el-tab-pane>
          <el-tab-pane label="已完成">
            <el-table
              :data="details.list_com1"
              border
               height="250"
              style="width: 100%">
              <el-table-column
                label="序号"
                align="center"
                type="index"
                :index="indexAdd"
                width="50"/>
               </el-table-column>
              <el-table-column
                prop="companyee"
                label="姓名"
                width="150">
              </el-table-column>
              <!-- <el-table-column
                label="考核状态"
               >
                <template slot-scope="scope">
                  <span v-if="scope.row.start=='0'" style="color: red;">
                    未通过
                  </span>
                  <span v-else>
                    通过
                  </span>
                </template>
              </el-table-column> -->
              <el-table-column
                label="操作"
               >
                <template slot-scope="scope">
                  <!-- <el-button
                  @click="train_companyee_remove(nav_status.train_info_dialog.data,scope.row,num.completed_list,'completed_list')"
                  type="text" size="small">移除</el-button> -->
                  <el-popconfirm title='确认移除？？？'
                       confirm-button-text='确定'
                       cancel-button-text='取消'
                       icon='el-icon-delete'
                       icon-color='red'
                       @confirm='handleConfirm_move(scope.row.num)'
                       @cancel='handleCancel'>
                       <span slot='reference'>移除</span>
                   </el-popconfirm>
                  <el-button
                   @click="subject_list(scope.row)"
                   type="text" size="small">查看问卷</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
          <el-tab-pane label="已移除人员">
            <el-table
            :data="details.list_com2"
            border
             height="250"
            style="width: 100%">
            <el-table-column
              label="序号"
              align="center"
              type="index"
              :index="indexAdd"
              width="50"/>
             </el-table-column>
            <el-table-column
              prop="companyee"
              label="姓名">
            </el-table-column>
          </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-row>

      <span slot="footer" class="dialog-footer">
        <el-button @click="details.show= false">关 闭</el-button>
      </span>
    </el-dialog>


  </el-row>
</template>

<script>
  import load from "../../../../components/load.vue"
    export default {
      data() {
        return {
          dialog_height:window.innerHeight * 0.7 + 'px',
          liad_show:false,
          pagination:{
            limit:4,
            currentPage:1,
            total:0,
          },
          type_show:'one',
          list:{},
          input:'',
          no_list:[{
            name:'创建',
          },
          {
            name:'发布',
          },
          {
            name:'记录',
          },],
        retrieval:{//检测
          show:false,
          list:{
            list:[],
            false_count:"",
          },
          again_list:[],
          bomkey_all:'',
          num:'',
        },
        details:{//详情
          list_com1:[],//完成人员
          list_com0:[],//未完成人员
          list_com2:[],//已移除人员
          list_info:[],//其他信息
          show:false,//弹窗
          num:'',//当前点击的任务
        },
        }
      },
      components: {
        load:load
      },
      mounted () {
        this.get_info()
      },

      methods: {
        subject_list(item){
          console.log(item)
          this.$router.push({path:'/quest_data_see',query:{num:item.num}})
        },
        name_goto(num){
          this.$router.push({path:'/quest_preview',query:{num:num}})
        },
        handleConfirm_move(num){
            let _this=this
            _this.liad_show=true
            _this.axios.post("/v2/c_investigate/investigate_push_remove_companyee",{data:num}).then(function (res) {
              if(res.status == "200"){
                if(res.data.code=='1'){
                  _this.liad_show=false
                  _this.$message.success(res.data.msg)
                  _this.get_details(_this.details.num)
                }else{
                  _this.$message.error(res.data.msg)
                  _this.liad_show=false
                }
              }else{
                _this.liad_show=false
                _this.$message.error("服务器内部错误")
              }
            })
        },
        handleCancel(){
        },
        indexAdd(index) {
          return index + 1
        },
        selectable(row){
         if(row.status){
           return false
         }else{
           return true
         }
        },
        again_Change(val){
          let _this=this
          _this.retrieval.again_list=val
        },
        again(){
          let _this=this
          if(_this.retrieval.again_list.length==0 ){
            _this.$message.warning('监测人员不能为空哦！！！')
            return
          }
          let data={
            num: _this.retrieval.num,
            companyee:_this.retrieval.again_list
          }
          _this.axios.post("/v2/c_investigate/investigate_push_re",{data:data}).then(function (res) {
            if(res.status == "200"){
              if(res.data.code=='1'){
                _this.$message.success(res.data.msg)
                _this.liad_show=false
                _this.get_retrieval(_this.retrieval.num)
              }else{
                _this.$message.error(res.data.msg)
                _this.liad_show=false
              }
            }else{
              _this.liad_show=false
              _this.$message.error("服务器内部错误")
            }

          })
        },
        input_change(){
          this.pagination.limit=4
          this.pagination.currentPage=1
          this.get_info()
        },
        handleSizeChange(val) {
          this.pagination.limit=val
          this.get_info()
        },
        handleCurrentChange(val) {
          this.pagination.currentPage=val
          this.get_info()
        },
        get_info(){
          let _this=this
          _this.liad_show=true
          _this.axios.get("/v2/c_investigate/investigate_push_list",{params: {
            limit:_this.pagination.limit,
            page:_this.pagination.currentPage,
            keyword:_this.input
          }}).then(function (res) {
            if (res.status == "200") {
              if(res.data.code=='1'){
                _this.pagination.total=res.data.data.list.total
                _this.pagination.currentPage=res.data.data.list.current_page
                _this.list=res.data.data.list.data
                _this.liad_show=false
              }else{
                _this.$message.error(res.data.data.msg)
                _this.liad_show=false
              }
            } else {
              _this.liad_show=false
              _this.$message.error("服务器内部错误")
            }
          })
          // _this.liad_show=false
        },
        handleConfirm_del(num){
            this.goto('del',num)
        },
        handleConfirm_dis(num){
            this.goto('Disable',num)
        },
        goto(type,num){
          let _this=this
          if(type=='del'){
            _this.post_del_dis(num,-1)
          }else if(type=='Disable'){
            _this.post_del_dis(num,0)
          }else if(type=='details'){
            _this.get_details(num)
          }else if(type=='data'){
            _this.$router.push({name:'quest_data_details',query: {num:num}})
          }else if(type=='retrieval'){
            _this.get_retrieval(num)
          }
        },
        post_del_dis(num,type){
          let _this=this
          _this.liad_show=true
          let data={
            num:num,
            status:type
          }
          _this.axios.post("/v2/c_investigate/investigate_push_status",{data:data}).then(function (res) {
            if(res.status == "200"){
              if(res.data.code=='1'){
                _this.liad_show=false
                _this.$message.success(res.data.msg)
                _this.get_info()
              }else{
                _this.$message.error(res.data.msg)
                _this.liad_show=false
              }
            }else{
              _this.liad_show=false
              _this.$message.error("服务器内部错误")
            }
          })
        },
        get_details(num){
          let _this=this
          _this.liad_show=true
          _this.details.num=''
          _this.details.list_com1=[]
          _this.details.list_com0=[]
          _this.details.list_com2=[]
          _this.axios.get("/v2/c_investigate/investigate_push_info",{params: {
            num:num,
          }}).then(function (res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                _this.details.num=num
                _this.details.list_info=res.data.data.info
                _this.details.list_com=res.data.data.companyee
                for(let i=0;i<res.data.data.companyee.length;i++){
                  if(res.data.data.companyee[i].status=='1'){
                    // _this.num.completed_num++
                    _this.details.list_com1.push(res.data.data.companyee[i])
                  }else if(res.data.data.companyee[i].status=='-1'){
                    // _this.num.incomplete_num++
                     _this.details.list_com2.push(res.data.data.companyee[i])
                  }else{
                    _this.details.list_com0.push(res.data.data.companyee[i])
                  }
                }
                console.log(_this.details.list_com1)
                _this.liad_show=false
                _this.details.show=true
              }else{
                _this.$message.error(res.data.msg)
                _this.liad_show=false
              }
            }else{
              _this.liad_show=false
              _this.$message.error('内部服务器错误！！！')
            }

          })
        },
        get_retrieval(num){
          let _this=this
          _this.liad_show=true
          _this.retrieval.num=''
          _this.axios.get("/v2/c_investigate/investigate_push_check",{params: {
            num:num,
          }}).then(function (res) {
            if(res.status=='200'){
              if(res.data.code=='1'){
                _this.retrieval.num=num
                // _this.pagination.total=res.data.data.list.total
                // _this.pagination.currentPage=res.data.data.list.current_page
                _this.retrieval.list=res.data.data
                _this.liad_show=false
                _this.retrieval.show=true
              }else{
                _this.$message.error(res.data.msg)
                _this.liad_show=false
              }
            }else{
              _this.liad_show=false
              _this.$message.error('内部服务器错误！！！')
            }

          })
        },
      }

    }
</script>

<style  scoped>
   .time {
      font-size: 13px;
      color: #999;
    }

    .bottom {
      margin-top: 13px;
      line-height: 12px;
    }

    .button {
      padding: 0;
      float: right;
    }

    .image {
      width: 100%;
      display: block;
    }

    .clearfix:before,
    .clearfix:after {
        display: table;
        content: "";
    }

    .clearfix:after {
        clear: both
    }
  >>>.el-input__inner{
    border-radius: 62.4375rem;
  }
  span{
     cursor: pointer;
  }
  .con_right{
     margin-right: 0.625rem;
     color: #7a7a7a;
  }
   .text {
      font-size: 14px;
    }

    .item {
      margin-bottom: 18px;
    }

    .clearfix:before,
    .clearfix:after {
      display: table;
      content: "";
    }
    .clearfix:after {
      clear: both
    }

    .box-card {
      width: 100%;
    }
</style>



// WEBPACK FOOTER //
// src/view/company/questionnaire/quest_data/list.vue